import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Stop",
  "use": "Stop-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"Stop\"><path fill=\"#fff\" fill-opacity=\".01\" d=\"M0 0h16v16H0z\" /><path d=\"M5.682 11.26a4 4 0 0 0 5.578-5.578l-5.578 5.579v-.001Zm-.942-.941 5.579-5.579a4 4 0 0 0-5.578 5.578H4.74ZM8 13.333A5.333 5.333 0 1 1 8 2.667a5.333 5.333 0 0 1 0 10.666Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol